export default {"src":"/_next/static/media/icon-dmca-takedown.70f738da.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};